module.exports = __webpack_public_path__ + "static/media/larry3.f9ab2193.mp3";